import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';

import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class HttpDocumentsService {
  private baseUrl = `${this.serverUrl}documents`;

  constructor(private httpClient: HttpClient, @Inject('API_URL') public serverUrl: string) {
  }

  public get(id: number): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/${id}`, {responseType: "blob"});
  }

}
